import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatwinsVariablesService } from '@app/common-codes/services/matwinsVariables.service';
import { NavigationService } from '@app/common-codes/services/navigation.service';

@Component({
  selector: 'app-qrcode-home',
  imports: [],
  templateUrl: './qrcode-home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``
})
export class QrcodeHomeComponent {


  constructor(
    private navService: NavigationService,
    private variables: MatwinsVariablesService
  ) { }

  ngOnInit() {

  }

  navigateToCheckin() {
    const route = `/qrcode/${this.variables.clientId}/${this.variables.posId}/visitor-type`;
    this.navService.navigateTo(route);
  }

  navigateToCheckout() {
    const route = `/qrcode/${this.variables.clientId}/${this.variables.posId}/checkout-type`;
    this.navService.navigateTo(route);
  }
}
